import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, FormHelperText, ButtonProps } from "@mui/material";

type ActionDialogProps = {
  open: boolean;
  title: string;
  helperText?: string;
  children: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  confirmLabel: string;
  confirmDisabled?: boolean;
  confirmButtonProps?: ButtonProps;
  cancelLabel?: string;
  maxWidth?: DialogProps["maxWidth"];
};

const ActionDialog: React.FC<ActionDialogProps> = ({
  open,
  title,
  helperText,
  children,
  onClose,
  onConfirm,
  confirmLabel,
  confirmDisabled,
  confirmButtonProps,
  cancelLabel = "Cancel",
  maxWidth = "sm",
}) => {
  const { sx: confirmButtonSx, ...restConfirmButtonProps } = confirmButtonProps || {};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      PaperProps={{
        sx: {
          borderRadius: 3,
          border: "1px solid #e2e8f0",
          backgroundColor: "#fff",
          boxShadow: "0 30px 60px rgba(15,23,42,0.12)",
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "1.05rem", fontWeight: 700, color: "#0f172a", pb: helperText ? 0 : 1 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ pt: helperText ? 0.5 : 1.5 }}>
        {helperText && (
          <FormHelperText sx={{ mb: 2, color: "#94a3b8" }}>
            {helperText}
          </FormHelperText>
        )}
        {children}
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          background: "#f8fafc",
          borderTop: "1px solid #e2e8f0",
          borderRadius: "0 0 16px 16px",
          gap: 1.5,
        }}
      >
        <Button onClick={onClose} sx={{ textTransform: "none", color: "#64748b" }}>
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={confirmDisabled}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            px: 3,
            minWidth: 110,
            ...(confirmButtonSx || {}),
          }}
          {...restConfirmButtonProps}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionDialog;

